const makeInHead = (tag, props) => {
  const element = document.createElement(tag);
  for (let prop in props) {
    element[prop] = props[prop];
  }
  document.head.appendChild(element);
  return element;
};

const promise = (element) =>
  new Promise((resolve, reject) => {
    element.onload = () => {
      console.log("Loaded:", element);
      resolve();
    };
    element.onerror = () => {
      console.error("Failed to load", element);
      reject();
    };
  });

export const addStyleElement = (textContent) => {
  const element = makeInHead("style", { textContent });
};

export const addLinkElement = (props = {}) => {
  const element = makeInHead("link", props);
  return promise(element);
};

// TODO Add support for text content
export const addScriptElement = (props = {}) => {
  const { id } = props;
  if (!id) throw new Error("Script ID is required");
  if (document.getElementById(id)) return;

  const element = makeInHead("script", props);
  return promise(element);
};
